<h1>
    <ng-content />
</h1>
